"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowHelper = void 0;
const client_1 = require("@prisma/client");
const creative_work_tagging_machine_1 = require("./creative-work-tagging/creative-work-tagging.machine");
const Workflow_dto_1 = require("./dto/Workflow.dto");
class WorkflowHelper {
    static title(workflow) {
        switch (workflow.workflowType) {
            case client_1.WorkflowType.CREATIVE_WORK_TAGGING: {
                const config = workflow.workflowConfig;
                const task = config.task === Workflow_dto_1.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_METADATA
                    ? 'Metadata'
                    : config.task ===
                        Workflow_dto_1.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_STORYLINES_RELATIONSHIPS
                        ? 'Storylines and Relationships'
                        : config.task;
                return `${task} Workflow`;
            }
            default: {
                return `Workflow ${workflow.workflowId}`;
            }
        }
    }
    static equals(workflowA, workflowB) {
        return workflowA.workflowId === workflowB.workflowId;
    }
    static can(workflow, event) {
        switch (workflow.workflowType) {
            case client_1.WorkflowType.CREATIVE_WORK_TAGGING: {
                return (0, creative_work_tagging_machine_1.creativeWorkTaggingMachineCan)(workflow, event);
            }
            default: {
                return false;
            }
        }
    }
    static isInQA(workflow) {
        switch (workflow.workflowType) {
            case client_1.WorkflowType.CREATIVE_WORK_TAGGING: {
                return creative_work_tagging_machine_1.CREATIVE_WORK_STATES_QA.includes(workflow.state);
            }
            default: {
                return false;
            }
        }
    }
    static lockDataTypes(workflow) {
        switch (workflow.workflowType) {
            case client_1.WorkflowType.CREATIVE_WORK_TAGGING: {
                const config = workflow.workflowConfig;
                let dataTypes;
                switch (true) {
                    case config.task === Workflow_dto_1.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_METADATA: {
                        dataTypes = ['metadata'];
                        break;
                    }
                    case config.task ===
                        Workflow_dto_1.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_STORYLINES_RELATIONSHIPS:
                        {
                            dataTypes = ['storylines', 'relationships'];
                            break;
                        }
                    default: {
                        throw new Error(`Cannot extract WIP data type from task type ${config.task}`);
                    }
                }
                return dataTypes;
            }
            default: {
                throw new Error(`Cannot extract WIP data type from workflow type ${workflow.workflowType}`);
            }
        }
    }
}
exports.WorkflowHelper = WorkflowHelper;
//# sourceMappingURL=WorkflowHelper.js.map